import { z } from "zod";
import RemoteCollection from "../utility/remote-collection";

export const UserListItemSchema = z.object({
  id: z.number(),
  name: z.string().nullish(),
  email: z.string().nullish(),
  accountName: z.string().nullish(),
  accountId: z.number().nullish(),
});

export const UserDetailItemSchema = UserListItemSchema.extend({
  phone: z.string().nullish(),
  isSuperAdmin: z.number().nullish(),
}).loose();

export type UserListItem = z.output<typeof UserListItemSchema>;
export type UserDetailItem = z.output<typeof UserDetailItemSchema>;

export const userCollection = new RemoteCollection("/api/user", UserListItemSchema, UserDetailItemSchema);

export function getUserCollectionForAccount(accountId: string) {
  return new RemoteCollection(`/api/account/${accountId}/user`, UserListItemSchema, UserDetailItemSchema);
}